<!--
作者：Loong
时间：2020/11/10
-->
<!-- PropertyWithdrawal [ 物业缴费提现 ] -->
<template>

    <div id='propertyWithdrawal' class="cash">
		<div class="cashMoney">
			<h1>可提金额（元）</h1>
			<el-input
			  placeholder="可提金额"
			  v-model="cashMoney"
			  style='height: 60px !important;'
			  :disabled="true"
			  clearable>
			</el-input>
			<rt>注：统计数据不包括当日的充值金额</rt>
		</div>
		
		<div class="cashTotal">
			<h1>收款账户</h1>
			<el-input
			  placeholder="收款账户"
			  v-model="cashTotal"
			  :disabled="true"
			  clearable>
			</el-input>
			<rt v-if="unbounded == 1" @click="onBounded">？未绑定账户信息，请点击这里</rt>
			<rt v-if="unbounded == 2" @click="showBounded">账户信息</rt>
		</div>
		<div class="cashmoney">
			<h1>提现金额（元）</h1>
			<el-input
			  placeholder="提现金额（元）"
			  v-model="money"
			  clearable>
			</el-input>
		</div>
		<div class="cashmoney">
			<h1>操作备注</h1>
			<el-input
			  placeholder="操作备注"
			  v-model="remark"
			  clearable>
			</el-input>
			<el-checkbox v-model="checkBox"></el-checkbox><rt class="service" >我已阅读并同意<rt style="color: #20a0ff;margin-left:3px;cursor: pointer;"@click="showService">服务协议</rt></rt>
		   	<el-button type="primary" class="sumbitCashMsg" @click="sumbitCash">申请</el-button>
		</div>
		   
		<!--绑定信息-->
		<div class="boundedMsg" v-if="showBoundBg">
			<div class="msgInfo" v-if="noBoundMsg">
				<h1 style="text-align: center;display: block;width: 100%;font-size: 16px;font-weight: normal;">账户信息</h1>
				<h2><rt>*</rt>账户名称</h2>
				<el-input v-model="companyName" placeholder="账户名称"></el-input>
				<h2><rt>*</rt>开户行名称</h2>
				<el-input v-model="openBank" placeholder="开户行名称"></el-input>
				<h2><rt>*</rt>银行账户</h2>
				<el-input v-model="bankAccount" placeholder="银行账户"></el-input>
				<p>注：请确保填写账户信息完整正确，确保与我公司签订的合同信息保持一致。因账户信息错误导致汇款经济纠纷以及法律责任均与我公司无关，一切责任由贵公司负责</p>
				<el-button type="primary" @click="sumbitBoundMsg">提交</el-button>
				<el-button type="primary" @click="closeSumbitBoundMsg">关闭</el-button>
			</div>
			<div class="msgInfo" v-if="boundMsg">
				<h1 style="text-align: center;display: block;width: 100%;font-size: 16px;font-weight: normal;">账户信息</h1>
				<h2><rt>*</rt>账户名称</h2>
				<el-input v-model="companyName" placeholder="账户名称"  :disabled="true"></el-input>
				<h2><rt>*</rt>开户行名称</h2>
				<el-input v-model="openBank" placeholder="开户行名称"  :disabled="true"></el-input>
				<h2><rt>*</rt>银行账户</h2>
				<el-input v-model="bankAccount" placeholder="银行账户"  :disabled="true"></el-input>
				<p>注：请确保填写账户信息完整正确，确保与我公司签订的合同信息保持一致。因账户信息错误导致汇款经济纠纷以及法律责任均与我公司无关，一切责任由贵公司负责</p>
				<el-button type="primary" @click="closeBoundMsg">关闭</el-button>
			</div>
			<div class="serviceAgreement" v-if='serviceAgreement'>
				<div class="agreement">
					<p v-html="agreement">
						
					</p>
					
				</div>
				<el-button type="primary" @click="closeService" style="margin-top: 50px;width: 100px;">关闭</el-button>
			</div>
			<div class="sumbitCash"  v-if="showSumbitCash">
				<ul>
					<li>
						账户名称：{{companyName}}
					</li>
					<li>
						开户行名称：{{openBank}}
					</li>
					<li>
						银行账户：{{bankAccount}}
					</li>
					<li>
						提现金额（元）：<span style="color: red;">{{money}}</span>
					</li>
					<li>
						操作备注：{{remark}}
					</li>
					<li>
						<el-button type="primary" @click="showSumbitcash">确定</el-button>
						<el-button type="primary" @click="closeSumbitCash">取消</el-button>
					</li>
				</ul>
			</div>
		</div>
    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
    components: { },

    props: [],

    data() {
        return{
            cashMoney:'',
            cashTotal:'',
            money:'',
            remark:'',
            checkBox:false,
            unbounded:'1',
            showBoundBg:false,
            noBoundMsg:false,
            boundMsg:false,
            companyName:'',
            openBank:'',
            bankAccount:'',
            agreement:'',
            serviceAgreement:false,
            showSumbitCash:false,
            allCashMoney:0
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){
        this.postCashData()
    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){

        },

        getData(){

        },

        postCashData:function postCashData(){
            this.$jssdk.property_lift.info({
                
            },(res)=>{
                console.log(res)
                this.cashMoney = '余额：'+Number(res.can_lift).toFixed(4)+'元'
                this.allCashMoney = res.can_lift
                this.cashTotal = '银行卡：'+res.invoice_acount_xin
                this.companyName = res.invoice_account_name
                this.openBank = res.invoice_bank_name
                this.bankAccount = res.invoice_acount
                if(res.invoice_acount_xin == ''){
                    this.unbounded = '1'
                }else{
                    this.unbounded = '2'
                }
                
            },(err)=>{
                this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:1000
                })
            })
        },
        showSumbitcash(){
            this.$jssdk.property_lift.create({
                money:this.money,
                remark:this.remark
            },(res)=>{
                this.$message({
                    type:'success',
                    message:res,
                    duration:1000
                })
                    this.showBoundBg = false
                    this.serviceAgreement = false
                    this.boundMsg = false
                    this.noBoundMsg = false
                    this.showSumbitCash = false
                    this.money = ''
                    this.remark = ''
            },(err)=>{
                this.$message({
                    type:'warning',
                    message:err.msg,
                    duration:1000
                })
            })
            console.log(1)
        },
        sumbitCash(){
            console.log(this.money,this.cashMoney)
            var a = ''
                if(this.money == ''){
                    return this.$message({
                        type:'warning',
                        message:'提现金额不能为空',
                        duration:1000
                    })
                }else if(Number(this.money) > Number(this.allCashMoney)){
                    return this.$message({
                        type:'warning',
                        message:"提现金额不能大于可提现金额",
                        duration:1000
                    })
                }
                if(this.money <= 0){
                    return this.$message({
                        type:'warning',
                        message:'提现金额不能小于等于0',
                        duration:1000
                    })
                }
                if(this.checkBox == false){
                    return this.$message({
                        type:'warning',
                        message:'请勾选是否同意服务协议',
                        duration:1000
                    })
                }
                if(this.unbounded == 1){
                    return this.$message({
                        type:'warning',
                        message:'请完善账户信息',
                        duration:1000
                    })
                }
                this.showBoundBg = true
                this.serviceAgreement = false
                this.boundMsg = false
                this.noBoundMsg = false
                this.showSumbitCash = true
	 		},
			showService(){
				this.showBoundBg = true
				this.serviceAgreement = true
				this.boundMsg = false
				this.noBoundMsg = false
				this.showSumbitCash = false
				this.$jssdk.property_lift.agreement({},(res) =>{
					this.agreement = res
				},(err) =>{
					
				})
			},
			onBounded(){
				this.showBoundBg = true
				this.boundMsg = false
				this.serviceAgreement = false
				this.noBoundMsg = true
				this.showSumbitCash = false
			},
			showBounded(){
				this.showBoundBg = true
				this.noBoundMsg = false
				this.serviceAgreement = false
				this.boundMsg = true
				this.showSumbitCash = false
			},
			sumbitBoundMsg(){
				if(this.companyName == ''){
					return this.$message({
						type:'warning',
						message:'请输入账户名称',
						duration:1000
					})
				}
				if(this.openBank == ''){
					return this.$message({
						type:'warning',
						message:'请输入开户行名称',
						duration:1000
					})
				}
				if(this.bankAccount == ''){
					return this.$message({
						type:'warning',
						message:'请输入银行账户',
						duration:1000
					})
				}
				this.$jssdk.lift.addAccount({
					invoice_account_name:this.companyName,
					invoice_bank_name:this.openBank ,
					invoice_acount:this.bankAccount 
				},(res)=>{
					this.showBoundBg = false
					this.$message({
						type:'success',
						message:'添加成功',
						duration:1000
					})
					this.postCashData()
				},(err) =>{
					
				})
				
			},
			closeBoundMsg(){
				this.showBoundBg = false
				this.boundMsg = false
			},
			closeService(){
				this.showBoundBg = false
				this.serviceAgreement = false
				this.boundMsg = false
				this.noBoundMsg = false
				this.showSumbitCash = false
			},
			closeSumbitCash(){
				this.showBoundBg = false
				this.serviceAgreement = false
				this.boundMsg = false
				this.noBoundMsg = false
				this.showSumbitCash = false
			},
			closeSumbitBoundMsg(){
				this.showBoundBg = false
				this.noBoundMsg = false
			}
		},
}
</script>

<style lang='less'>

</style>

<style>
.sumbitCash{
		margin-top: 10%;	
}
.sumbitCash ul{
	width: 600px;
	margin: 0 auto;
	background-color: white;
	list-style: none;
	padding: 0;
	border-radius: 10px;
	margin-top: 5%;
}
.sumbitCash ul li{
	padding: 20px;
	height: 30px;
	line-height: 30px;
	border-bottom: 1px solid #ccc;
	font-size: 14px;
}
.sumbitCash ul li button{
	width: 100px;
}
.sumbitCash ul li:last-child{
	text-align: center;
	border: none;
}
.sumbitCashMsg{
		width: 150px;
		margin: 20px;
		display:block !important;
}
.service{
	font-size: 12px;
	margin: 20px;
	display:inline-block;
}
.agreement{
	width: 800px;
	height: 600px;
	margin: 0 auto;
	overflow: auto;
	background-color: white;
	margin-top: 5%;
	border:2px solid #8fceff;
	border-radius: 10px;
	box-shadow: 5px 10px 10px rgba(51,51,51,.3);
	padding: 15px;
	text-align: left;
}
.agreement h2{
	text-align: center;
	font-size: 18px;
	font-weight: normal;
}
.agreement p{
	text-indent: 2em;
}
.serviceAgreement{
	text-align: center;
}
.serviceAgreement button{
	width: 100px;
}
.msgInfo{
	width: 400px;
	height: 480px;
	border: 1px solid white;
	margin: 0 auto;
	margin-top: 10%;
	background-color: #fff;
	padding: 15px;
	border-radius: 10px;
	text-align: center;
}
.msgInfo p{
	color: red;
	font-size: 14px;
	text-align: left;
}
.msgInfo h2{
	font-size: 14px;
	font-weight: normal;
	text-align: left;
}
.msgInfo h2 rt{
	color: red;
}
.msgInfo button{
	width: 150px;
	margin-top: 25px;
}
.boundedMsg{
	width:100%;
	background-color: rgba(0,0,0,.7);
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 20;
}
.cash{
	overflow: hidden;
	padding: 20px;
}
.cash h1{
	font-size: 14px;
	margin:0 auto ;
	float: left;
	display: inline-block;
	height: 60px;
	line-height: 60px;
}
.cashMoney{
	width: 50%;
	overflow: hidden;
}
.cashMoney input{
	height: 60px ;
}
.cashMoney rt{
	font-size: 12px;
	color: red;
	height: 60px;
	line-height: 60px;
}
.cashTotal{
	width: 50%;
	overflow: hidden;
}
.cashTotal input{
	height: 60px ;
}
.cashTotal rt{
	font-size: 12px;
	color: red;
	height: 60px;
	line-height: 60px;
	cursor: pointer;
}
.cashmoney{
	width: 50%;
	overflow: hidden;
}
.cashmoney input{
	height: 60px ;
}
.cashmoney button{
	margin: 0 auto;
}
</style>




// WEBPACK FOOTER //
// PropertyWithdrawal.vue?4d7c1646